import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-diagnostic',
  templateUrl: './edit-animal-diagnostic.component.html',
  styleUrls: ['./edit-animal-diagnostic.component.css']
})
export class EditAnimalDiagnosticComponent implements OnInit {
  getdiagnosticeditApi:any;
  putdiagnosticeditApi:any;
  EditDiagnosticFormValue:any;
  loginresponse:any;
  cby_mby:any;
  addUrl:any;
  getlistApi:any;
  getDiseaseListData:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

 async ngOnInit() {
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.cby_mby=this.loginresponse.user_id;
    let DiagnosticId = sessionStorage.getItem('diagnosticId');
    this.getdiagnosticeditApi= "/animal_management/diagnostics/"+ DiagnosticId;
    this.putdiagnosticeditApi= "/animal_management/diagnostics/"+ DiagnosticId;
    (await this.commonService.getApi(this.getdiagnosticeditApi)). subscribe(
    (res:any) => {
         var date=res.data.tnam_dgn_date_of_test;
         var testdate = date.split('T');
        $("#Dateoftest").val(testdate[0])       
         $("#Diagnostictest").val(res.data.tnam_dgn_diagnostics_test_name)
         $("#Description").val(res.data.tnam_dgn_diagnostics_description)
        })
  }
  
  async AnimalDiagnostic(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditDiagnosticFormValue = {
      "species_id":speciesid,
      "breed_id":breedid,
      "farm_id":farmid,
      "animal_code":Animalid,
      "age_group":ageid,
      "diagnostics_test_name":$("#Diagnostictest").val(),
      "date_of_test":$("#Dateoftest").val(),
      "diagnostics_description":$("#Description").val(),
      "cby":this.cby_mby,
      "mby":this.cby_mby,
      "status": 1,
      "is_active": 1
  };
    (await this.commonService.putApi(this.putdiagnosticeditApi,this.EditDiagnosticFormValue)).subscribe(
      data => {
          alert("Data edited successfully");
      });
      setTimeout(
        () : void => {
       
     this.router.navigate([this.returnUrl,{ fragment: 'Disease' }]);

        },
        500
      );
//}
  }

  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
